import React, { useContext, useState, useEffect } from "react";
import { Backdrop, Box, Button, CircularProgress, IconButton, Grid, Slide, Typography } from "@mui/material";
import bkstApi from "../../common/api";
import ConfigContext from "../../common/context/ConfigContext";
import { Link as RouterLink } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import Preview from "../../common/component/Preview";
import Contact from "../../common/component/Contact";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const navBtnStyle = {
  position: "absolute",
  zIndex: 2,
  top: "50%",
  transform: "translateY(-50%)",
  color: "#000",
  backgroundColor: "#fff",
  borderColor: "#ebebeb",
  opacity: ".7",
  padding: "0"
};

const navBtnPrevStyle = Object.assign({ left: "8px" }, navBtnStyle);
const navBtnNextStyle = Object.assign({ right: "8px" }, navBtnStyle);

export default function CustomPage(props) {
  const siteConfig = useContext(ConfigContext);

  let location = useLocation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [page, setPage] = useState("");

  useEffect(() => {
    bkstApi(`/site/${siteConfig.id}/page/${props.handle}`).then((res) => {
      setPage(res.data.page);
    });
  }, []);

  const getSection = (section) => {
    if (section.layout === "fullWidth") {
      if (section.media.type === "video") {
        return (
          <Box id={section.id} style={section.style || {}}>
            <Box
              position="relative"
              width="100vw"
              left="50%"
              right="50%"
              ml="-50vw"
              mr="-50vw"
              sx={{
                aspectRatio: "16/9",
                minHeight: { xs: 320, sm: 480, md: 600 },
                maxHeight: { xs: 480, sm: 600, md: 800 },
                background: "#111",
                overflow: "hidden"
              }}
            >
              <video
                src={section.media.src}
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: "100vw",
                  height: "100%",
                  objectFit: "contain",
                  background: "#111",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 1
                }}
              />
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                zIndex={2}
                sx={{
                  background: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.25))",
                  color: "#fff",
                  textShadow: "0 2px 8px rgba(0,0,0,0.5)"
                }}
              >
                <Typography sx={{ fontSize: "calc(100% + 3vw)", fontWeight: "700", fontWeight: 700 }}>{section.title}</Typography>
                <Typography sx={{ mt: 2, fontSize: "calc(80% + 1vw)" }}>{section.subtitle}</Typography>
              </Box>
            </Box>
          </Box>
        );
      } else if (section.media.type === "image") {
        return (
          <Box id={section.id} textAlign="center" sx={{ height: "90vh", backgroundImage: section.media.src, backgroundSize: "cover" }}>
            <Slide direction="down" in={true} mountOnEnter unmountOnExit timeout={500}>
              <Box>
                <Typography variant="h1" style={{ color: section.color || "#fff", fontSize: "calc(100% + 3vw)", fontWeight: "700" }}>
                  {section.title}
                </Typography>
                <Typography variant="subtitle1" style={{ color: section.color || "#fff", fontSize: "calc(80% + 1vw)" }}>
                  {section.subtitle}
                </Typography>
              </Box>
            </Slide>
          </Box>
        );
      }
    } else if (section.layout === "grid") {
      return (
        <Box id={section.id} className="flex-container" style={section.style || { display: "flex", justifyContent: "center" }}>
          {section.parts.map((o, idx) => {
            if (o.content) {
              return (
                <Box sx={o.style || {}}>
                  <Box mb={2}>
                    <Typography variant="h2" sx={{ fontSize: "calc(100% + 2.2vw)" }}>
                      {o.title}
                    </Typography>
                    <Typography variant="subtitle1" sx={{ fontSize: "calc(75% + .75vw)" }} color="textSecondary">
                      {o.subtitle}
                    </Typography>
                  </Box>
                  <Preview lines="15">
                    <Typography
                      variant="subtitle1"
                      sx={{ textAlign: "justify" }}
                      dangerouslySetInnerHTML={{
                        __html: o.content
                      }}
                    />
                  </Preview>
                  {section.cta && (
                    <Box mt={4} textAlign={"center"}>
                      <Button component={RouterLink} variant="contained" color="primary" to={section.cta.link} size="large" sx={{ fontSize: "24px" }}>
                        {section.cta.title}
                      </Button>
                    </Box>
                  )}
                </Box>
              );
            } else if (o.media.type === "image") {
              return (
                <Box sx={o.style || {}}>
                  <img alt={o.title} style={{ width: "100%", aspectRatio: "1", objectFit: "cover", borderRadius: "4px" }} src={o.media.src} />
                </Box>
              );
            } else if (o.media.type === "carousel") {
              return (
                <Box sx={o.style || {}}>
                  <Carousel
                    autoPlay={false}
                    infiniteLoop
                    interval={3000}
                    transitionTime={1500}
                    showArrows={true}
                    showIndicators={true}
                    showStatus={true}
                    showThumbs={false}
                    renderArrowPrev={(onClickHandler, hasPrev, label) =>
                      hasPrev && (
                        <IconButton onClick={onClickHandler} title={label} style={navBtnPrevStyle}>
                          <ChevronLeftIcon />
                        </IconButton>
                      )
                    }
                    renderArrowNext={(onClickHandler, hasNext, label) =>
                      hasNext && (
                        <IconButton onClick={onClickHandler} title={label} style={navBtnNextStyle}>
                          <ChevronRightIcon />
                        </IconButton>
                      )
                    }
                  >
                    {o.media.src.map((pic, idx) => {
                      return (
                        <Box key={idx}>
                          <img alt={o.title} style={{ width: "100%", aspectRatio: "1", objectFit: "cover", borderRadius: "4px" }} src={pic} />
                        </Box>
                      );
                    })}
                  </Carousel>
                </Box>
              );
            }
          })}
        </Box>
      );
    } else if (section.layout === "contact") {
      return (
        <Box id={section.id} style={section.style || {}}>
          <Grid container spacing={2}>
            <Grid item md={3} sm={2} xs={12}></Grid>
            <Grid item md={6} sm={8} xs={12}>
              <Box mb={2} textAlign="center">
                <Typography variant="h2" sx={{ fontSize: "calc(100% + 2.2vw)" }}>
                  {section.title}
                </Typography>
                <Typography variant="subtitle1" sx={{ fontSize: "calc(75% + .75vw)" }} color="textSecondary">
                  {section.subtitle}
                </Typography>
              </Box>
              <Contact title={page.title} />
            </Grid>
          </Grid>
        </Box>
      );
    }
  };

  if (page) {
    return (
      <Box>
        {page.sections.map((section, idx) => {
          return getSection(section);
        })}
      </Box>
    );
  } else {
    return (
      <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
}
